export default "__VITE_ASSET__cc9f3134__"